'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var tableContent = require('./table-content-819f8098.js');

var StyledTable = styled__default.table(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  border-spacing: 0;\n  color: ", ";\n  border-top: 1px solid ", ";\n  background-color: ", ";\n"], ["\n  width: 100%;\n  border-spacing: 0;\n  color: ", ";\n  border-top: 1px solid ", ";\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
});
var NewTable = function (_a) {
    var className = _a.className, dataCy = _a.dataCy, dataTestId = _a.dataTestId, children = _a.children, columns = _a.columns, rows = _a.rows, toggleRow = _a.onToggleRow;
    return (React__default.createElement(StyledTable, { className: className, "data-cy": dataCy, "data-testid": dataTestId }, children || (React__default.createElement(tableContent.TableContent, { rows: rows, columns: columns, dataCy: dataCy, dataTestId: dataTestId, onToggleRow: toggleRow }))));
};
var templateObject_1;

exports.NewTable = NewTable;
